import { useState } from "react";
import { useGlobalContext } from "../../context/GlobalContext";


export function useIconColor() : 'white' | 'black'
{
    let context = useGlobalContext();

    let iconColor: 'white' | 'black' = context.Context!.GetTheme!() == 'dark' ? 'white' : 'black';    
    
    let [reload, setReload] = useState(0);      
    
    context.Context?.AfterThemeChangeEvent.Add(()=> setReload(p => p + 1));

    return iconColor;
}




